import React from 'react'
import SpinnerUI from '../../widgets/output/SpinnerUI'
import PublicPageSF from '../../templates/PublicPageSF'
import './SpinnerPage.css'

const SpinnerPageUI = ({context}) =>
  <PublicPageSF context={context} className='pg_spinner' centered={true}>
    <div className='g_flex_v spinner'>
      <SpinnerUI show={true} dimension='w80' />
    </div>
  </PublicPageSF>

export default SpinnerPageUI
